import React from 'react';
import {FormDialog, Button} from 'components/core';
import FilesList from 'components/files/FilesList';
import {ProceduresCtx, ProcedureFilesCtx} from 'components/dataProviders/procedures';
import {Add} from '@material-ui/icons';
import {TagsCtx} from 'components/dataProviders/tags';
import { ProcedureItemsCtx } from 'components/dataProviders/procedureItems';
import { makeStyles } from '@material-ui/core/styles';
import {GetAsFormField} from './templateField';
const useStyles = makeStyles((theme) => ({
  dialog:
  {
    width: 700
  }
}), {name: "EditProcedureDialog"});

export default function EditProcedureDialog({open, handleClose=()=>{}, handleConfirm=()=>{}, procedureID})
{
    const classes = useStyles();
  
    const procsCtx = React.useContext(ProceduresCtx);
    const tagsCtx = React.useContext(TagsCtx);
    const itemsCtx = React.useContext(ProcedureItemsCtx);
    const filesCtx = React.useContext(ProcedureFilesCtx);

    const procedure = procsCtx.data.indexed[procedureID];
    const templateFieldValues = {};
    
    if(procedure) procedure.templateFields.forEach((field) => templateFieldValues["templateField."+field.fieldID] = field.value );

    const [loading, setLoading] = React.useState(false);
    const [tagItems, setTagItems] = React.useState([]);
    const [items, setItems] = React.useState([]);
    //const [values, setValues] = React.useState({name: procedure.name, description: procedure.description, executionTime: procedure.executionTime, items: procedure.items, tags: procedure.tags, ...templateFieldValues});
    

    React.useEffect(function initializeTags() {
      let tags = [];
      tagsCtx.data.active.forEach((item) => tags.push({value: item.tagID, content: item.name}));

      setTagItems(tags);
  }, [tagsCtx]);

  React.useEffect(function initializeItems() {
    let items = [];
    itemsCtx.items.array.forEach((item) => items.push({value: item.itemID, content: <>{/*<ItemDrawer itemID={item.itemID} />*/}{item.name}</>}));

    setItems(items);
}, [itemsCtx]);

    const onConfirm = (values) => {
      setLoading(true);

      Object.keys(values).forEach((key) => {
        if(key.startsWith("templateField."))
        {
          if(!values.templateFields) values.templateFields = [];

          let fieldID = parseInt(key.split(".")[1]);
          let assigned = false;
          values.templateFields.forEach((field) => {
            if(field.fieldID === fieldID)
            {
              field.value = values[key];
              assigned = true;
            }
          });
          if(!assigned) values.templateFields.push({fieldID: fieldID, value: values[key]});

          delete values[key];
        }
      });

      procsCtx.funcs.update(procedureID, values).then(() => {
        setLoading(false);
        handleConfirm();
      });
    }

    const uploadFile = React.useCallback(() =>
    {
        filesCtx.funcs.upload();
    }, [filesCtx]);


    if(!procedure) return null;

    const templateFields = procedure.templateFields.map((field) => GetAsFormField(field));
    

    return <FormDialog
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      title="Editar procedimiento"
      subtitle="Rellena los campos con toda la información relacionada con el procedimiento"
      confirm="Siguiente"
      cancel="Cancelar"
      loading={loading}
      className={classes.dialog}
      fields={[
        {
          type: "text",
          label: "Nombre",
          id: "name",
          placeholder: "Nombre del procedimiento",
          mandatory: true,
          value: procedure.name
        },
        {
          type: "textarea",
          label: "Descripción",
          id: "description",
          placeholder: "",
          mandatory: false,
          value: procedure.description
        },
        {
          type: "timespan",
          label: "Duración estimada",
          id: "executionTime",
          placeholder: "",
          mandatory: false,
          value: procedure.executionTime
        },
        {
          type: "tagSelector",
          label: "Añadir items",
          id: "items",
          value: procedure.items,
          placeholder: "Sin items",
          items: items
        },
        {
          type: "tagSelector",
          label: "Añadir etiquetas",
          id: "tags",
          placeholder: "Sin etiquetas",
          value: procedure.tags,
          items: tagItems
        },
        ...templateFields,
        {
          type: "custom",
          label: "Archivos",
          content: <><FilesList context={ProcedureFilesCtx} editable/><Button fullWidth={false} color="primary" onClick={()=>uploadFile()}><Add />Añadir Archivo</Button></>
        }
      ]}
      />
}
